import React from 'react';
import PropTypes from 'prop-types';

// Page numbers to show: the first, the last and the current one with its
// neighbours; a gap between them shows as "…".
function pageNumbers(page, pages) {
  const shown = Array.from({ length: pages }, (_, i) => i + 1).filter(
    n => n === 1 || n === pages || Math.abs(n - page) <= 1
  );
  return shown.reduce((acc, n, i) => {
    if (i > 0 && n - shown[i - 1] > 1) acc.push('…');
    acc.push(n);
    return acc;
  }, []);
}

/**
 * "from–to of total" and the page buttons under a paged list (the Plan
 * projects list, Predict's watch list). Styles: projectsList.css.
 */
const Pager = ({ page, pages, from, to, total, onPage }) => (
  <div className="pl-pager">
    <span className="bz-muted">
      {from}–{to} of {total}
    </span>
    {pages > 1 && (
      <div className="pl-seg">
        <button type="button" disabled={page === 1} aria-label="Previous page" onClick={() => onPage(page - 1)}>
          ‹
        </button>
        {pageNumbers(page, pages).map((n, i) =>
          n === '…' ? (
            <button type="button" key={`gap-${i}`} disabled>
              …
            </button>
          ) : (
            <button type="button" key={n} className={n === page ? 'is-on' : ''} onClick={() => onPage(n)}>
              {n}
            </button>
          )
        )}
        <button type="button" disabled={page === pages} aria-label="Next page" onClick={() => onPage(page + 1)}>
          ›
        </button>
      </div>
    )}
  </div>
);
Pager.propTypes = {
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  from: PropTypes.number.isRequired,
  to: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onPage: PropTypes.func.isRequired
};

export default Pager;
